window.addEventListener("DOMContentLoaded", (event) => {
if (screen.width > 500) {
/*const main = document.querySelector(".main-content");
main.addEventListener('click', (event) => {
  document.querySelector('.js-drawer-close button').click();
});*/

const footer = document.querySelector(".footer-wrapper");
footer.addEventListener('click', (event) => {
  document.querySelector('.js-drawer-close button').click();
});
}
  if (location.href.includes("tagged")) {
    toggleFilters();
  }
});

function displayForm(formId) {
  var notifyForm = document.querySelector('img[product-id="'+formId+'"] + .da-restock-collection-img-v3-wrapper');
  notifyForm.classList.toggle('revealForm');
}

function toggleFilters() {
  var filters = document.querySelector('.recipe-filters');
  filters.classList.toggle('revealFilters'); 
}

/* Dropdown */
function filterRecipes() {
  var diet = document.querySelector('#diet-filter').value.toLowerCase();    
  var type = document.querySelector('#type-filter').value.toLowerCase();
  var redirectUrl = '/blogs/recipes/';
  const tags = [];
  if (diet != "all") { tags.push(diet); }
  if (type != "all") { tags.push(type); }
  var tagString = tags.join("+");
  if (tagString == "") {
    location.href = redirectUrl;        
  } else {
    location.href = redirectUrl + "tagged/" + tagString;    
  }
}

function navOpen() {
  var menuBtn = document.querySelector('.js-drawer-open-left-link');    
  menuBtn.classList.toggle("menu-open");
}

function filterRecipesCheckbox() {
  var redirectUrl = '/blogs/recipes/';
  const tags = [];
  var checkedBoxes = document.querySelectorAll('input[type="checkbox"]:checked');
  
  for (var i = 0; i < checkedBoxes.length; i++) {   
    if (checkedBoxes[i].name !== 'optInText') {
      tags.push(checkedBoxes[i].name);
    }
  }   
  var tagString = tags.join("+");
  if (tagString == "") {
    newUrl = redirectUrl;        
  } else {
    newUrl = redirectUrl + "tagged/" + tagString;    
  }

  location.href = newUrl;        
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".jump-links").forEach(function (wrapper) {
    const container = wrapper.querySelector("ul");
    const links = container ? container.querySelectorAll("a") : [];

    if (!container || links.length === 0) return;

    const dotsContainer = document.createElement("div");
    dotsContainer.className = "jump-dots";
    wrapper.appendChild(dotsContainer);

    links.forEach((_, i) => {
      const dot = document.createElement("span");
      if (i === 0) dot.classList.add("active");
      dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll("span");

    function updateActiveDot() {
      const maxScroll = container.scrollWidth - container.clientWidth;

      if (container.scrollLeft >= maxScroll - 5) {
        dots.forEach(dot => dot.classList.remove("active"));
        dots[dots.length - 1].classList.add("active");
        return;
      }

      let closestIndex = 0;
      let closestOffset = Infinity;

      links.forEach((link, i) => {
        const offset = Math.abs(link.offsetLeft - container.scrollLeft);

        if (offset < closestOffset) {
          closestOffset = offset;
          closestIndex = i;
        }
      });

      dots.forEach(dot => dot.classList.remove("active"));
      dots[closestIndex].classList.add("active");
    }

    container.addEventListener("scroll", updateActiveDot);
  });
});